import { Flex } from 'antd';
import { FetchingErrorState } from '@shared/ui/fetching-error-state/fetching-error-state';
import { LoadingState } from '@shared/ui/loading-state/loading-state';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '@shared/ui/page-header';
import type { FC } from 'react';
import { useGetAgentInfoAgentInfoGetQuery } from '@shared/api';
import { Prompt } from './ui/prompt/prompt';
import styles from './styles.module.scss';

interface AiAgentProps {
  agentId: number;
}

export const AiAgent: FC<AiAgentProps> = ({ agentId }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'aiAgent' });

  const { data, isLoading, isFetching, isError, refetch } = useGetAgentInfoAgentInfoGetQuery(
    {
      agentId: Number(agentId),
    },
    {
      skip: !agentId,
    },
  );

  return (
    <Flex vertical className={styles.root}>
      {(() => {
        if (isLoading || isFetching) {
          return <LoadingState />;
        }

        if (isError) {
          return <FetchingErrorState refetch={refetch} />;
        }

        if (!data) {
          return null;
        }

        return (
          <Flex vertical className={styles.content}>
            <PageHeader title={t('title')} />

            <Prompt agentId={Number(agentId)} />
          </Flex>
        );
      })()}
    </Flex>
  );
};
